import { TableFilled } from '@components/Table';
import styled from 'styled-components';
import { makeCalc } from '@utils/calcPercent';
import { AnchorText } from '@components/Text/AnchorText';
import { cloneStyled } from '@utils/cloneStyled';
import { Image } from '@mantine/core';

export const StyledDiv = styled.div`
  overflow: auto;

  .loadmore_wrap {
    padding-top: 12px;
  }
`;
export const StyledDivLoadingHeadings = styled.div`
  padding-top: 24px;

  display: grid;
  grid-template-columns: minmax(412px, min-content) 1.36fr 1.06fr 2.15fr 1fr;
  column-gap: 61px;
`;
export const StyledDivLoadingRows = styled.div`
  padding-top: 8px;

  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

const calcPercentDocs = makeCalc(1230, 61);
export const DocumentsTable = styled(TableFilled)`
  && {
    --row-height: 44px;
    --row-bg-hover: var(--beam-color-neutral-n100);
    --heading-background: #fff;
    --row-block-padding: 0;
    --row-left-padding: 12px;
    --row-right-padding: 12px;

    th[data-fieldname='label'] {
      width: ${calcPercentDocs(412)}%;
    }
    th[data-fieldname='associatedWithName'] {
      width: ${calcPercentDocs(136)}%;
    }
    th[data-fieldname='associatedWithSource'] {
      width: ${calcPercentDocs(106)}%;
    }
    th[data-fieldname='createdAt'] {
      /* 145+36+61 , last.*/
      width: ${calcPercentDocs(145) + calcPercentDocs(36, 0)}%;
    }
    /* Everything else is as wide as addedByName */
    th {
      width: ${calcPercentDocs(90)}%;
    }
    th > * {
      padding-top: 8px;
      padding-bottom: 0;
    }
  }
`;

export const StyledCell = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  justify-content: space-between;
`;

export const CellAnchorText = cloneStyled(
  AnchorText,
  styled(AnchorText)`
    overflow: hidden;
    white-space: nowrap;
    max-width: min-content;
  `,
);

export const CellGroup = styled.div`
  display: flex;
  column-gap: 6px;

  overflow: hidden;
  align-items: center;
`;
export const CellGroupAddedBy = styled(CellGroup)`
  column-gap: 8px;
`;
export const ProfileImg = styled(Image)`
  .mantine-Image-placeholder * {
    flex-shrink: 0;
  }

  /* If we add border, reduce width , height by 2px */
  /* border: 1px solid var(--beam-color-neutral-n400); */
  border-radius: 50%;
  overflow: hidden;
  box-sizing: content-box;
`;
